import script from "./SubmitAuthenticatorDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./SubmitAuthenticatorDialog.vue?vue&type=script&lang=ts&setup=true"

import "./SubmitAuthenticatorDialog.vue?vue&type=style&index=0&id=1dcacce6&scoped=true&lang=css"

import exportComponent from "D:\\x1\\vue3-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dcacce6"]])

export default __exports__